import { getListByDictType } from "@/api/sys/dictData";
const dict = {
    state: {
        cowProductType: [],//产品类型
       
    },
    mutations: {
        // set_proceeds_return_type: (state, proceeds_return_type) => {
        //     state.proceeds_return_type = proceeds_return_type
        // },

    },
    actions: {
        // 字典
        dictOption: ({ commit }) => {
            // getListByDictType('cow_product_type').then(res => {
            //     if (res?.code == 200) {
            //         commit("SET_COW_PRODUCT_TYPE", res.data);
            //     }
            // })
        },
    }
}
export default dict